<div class="row" style="margin-top:10px">
    <div class="col-3">
        <mat-form-field appearance="fill" class="gray-text" style="width:100%">    
            <mat-label>Select Flash Profile*</mat-label>
            <mat-select matNativeControl [ngModel]="profileId" (ngModelChange)="onProfileGroupChange($event)" [disabled]="!createFlashAccount">
                @if(profileList.length === 0) {
                    <mat-option value="">Loading Profiles...</mat-option>
                }
                @else {
                    <mat-option value="">Select Flash Profile</mat-option>
                    <mat-option *ngFor="let profile of profileList" [value]="profile.uniqueID" >
                    {{profile.name}} 
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
        <!-- <span style="font-weight:normal;font-size:14px;position:relative;top:-15px;left:10px;">By default Parker status = neutral, mode=normal</span>    -->
    </div>

    <div class="col-3">
        <mat-form-field appearance="fill" class="gray-text" style="width:100%">    
            <mat-label>Select Pool</mat-label>
            <mat-select matNativeControl [ngModel]="poolName" (ngModelChange)="onPoolGroupChange($event)" [disabled]="!createFlashAccount">
                <mat-option value="">Select Pool</mat-option>
                <mat-option *ngFor="let pool of poolList" [value]="pool.poolName">
                {{pool.poolName}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    
     <div class="col-2">
        <div style="margin-top:10px;">
            <mat-checkbox 
                matTooltip="Unchecking this will result in the Parker profile not being created in the Flash system."
                [(ngModel)]="createFlashAccount" (change)="onSaveFlashProfileChange()" 
                style="font-size:14px;color:gray" class="gray-text">
                    <span  style="font-weight:normal;" class="gray-text">Create Flash Account</span>
            </mat-checkbox>
         </div>
    </div>
    </div>





